module.exports = __webpack_public_path__ + "static/img/021_3.d7831bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/021_3.jpg
// module id = bKqj
// module chunks = 1